import { defineStore } from "pinia";
import { piniaPersistTosessionConfig } from "@/config/piniaPersist";
import { toObj } from "@/utils/tsxHelper";
import { getDataSetListCacheByTypeNameApi } from "@/api/modules/system/customdata";
//import { ref } from "vue";
export interface UploadState {
  urlsObj: Recordable;
}

export const useUploadUrlStore = defineStore({
  id: "system-uploadurls",
  state: (): UploadState => ({
    urlsObj: {}
  }),
  getters: {},
  actions: {
    getUploadUrlObj(name: string, type: string) {
      const key = `${name}-${type}`;
      if (key in this.urlsObj) {
        return this.urlsObj[key];
      }
      return "";
      // const { data } = await getDataSetListApi({ limit: 10, page: 1, custom_data_type_id: "516794722244550", name });
      // let look = ref(null);
      // let { source } = data.find((item: any) => item.meta)?.meta;
      // source.forEach((item: any) => {
      //   if (item.label === type) {
      //     look.value = item.value;
      //     this.urlsObj[key] = item.value;
      //   }
      // });
      // return look.value;
    },
    async uploadUrlInit() {
      if (localStorage.getItem("system-uploadurls")) return;
      const { data } = await getDataSetListCacheByTypeNameApi({ type_name: "sys_set_file_upload_address" });
      data.map(item => {
        const name = item.name;
        this.urlsObj[`${name}-allow`] = toObj(item.expand1, null);
        this.urlsObj[`${name}-not-allow`] = toObj(item.expand2, null);
        const { source } = item.meta;
        source.map(mitem => {
          const key = `${name}-${mitem.label}`;
          this.urlsObj[key] = mitem.value;
        });
      });
    }
  },
  persist: piniaPersistTosessionConfig("system-uploadurls")
});
